import { api } from '../services/axiosConfig';

export const setWaypoint = (destinationId: number, clearOtherWaypoints = true) =>
  api.post('/api/waypoint', { destinationId, clearOtherWaypoints });
